export const featureDetection = (window)=>{
    const testElem = document.createElement('div');
    const upgrade_browser_href = window.location.origin + '/upgrade_browser'
    if (!window.customElements || (testElem.style.flex === undefined || testElem.style.flexFlow === undefined)) {
        window.location.href = upgrade_browser_href
    }
}